import { GlobeIcon } from 'lucide-react';
import { ViewTypes } from '..';
import { Button } from '@repo/ui';

interface OwnerPublicPreviewHeaderProps {
  viewType: ViewTypes;
  setViewType: (viewType: ViewTypes) => void;
  /**
   * Where this preview was entered from. Preview is reachable two ways and the exit
   * should return you to whichever it was: the certificate's own kebab (back to the
   * owner view) or the Share screen's per-view Preview (back to Share). Sending
   * someone who was mid-way through configuring a link to a different page is a small
   * but real loss of place.
   */
  onExit?: () => void;
  exitLabel?: string;
}

export const OwnerPublicPreviewHeader = ({
  viewType,
  setViewType,
  onExit,
  exitLabel,
}: OwnerPublicPreviewHeaderProps) => {
  if (viewType !== ViewTypes.OWNER_PUBLIC_PREVIEW) return null;

  return (
    <div className='sticky top-0 z-[5] w-full px-4 py-3 flex justify-between items-center bg-gray-50 border-b border-border'>
      <div className='flex items-center gap-3'>
        <GlobeIcon size={20} />
        {/* "Public certificate preview" + "Back to owner view" is ~330px of text on a
            343px row. Shortening the LABEL (the globe already says "public") buys the
            room, rather than shortening the ACTION, which needs to stay unambiguous. */}
        <p className='text-sm font-medium'>Public preview</p>
      </div>
      <Button
        className='text-sm'
        variant='secondary'
        sx={{ paddingX: 2 }}
        onClick={() => (onExit ? onExit() : setViewType(ViewTypes.OWNER))}
      >
        {exitLabel || 'Back to owner view'}
      </Button>
    </div>
  );
};
